import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  EventEmitter,
  Output,
} from '@angular/core'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import {
  ActiveCartFacade,
  MultiCartFacade,
  CartVoucherFacade,
} from '@spartacus/cart/base/root'
import { RoutingService } from '@spartacus/core'
import { Router } from '@angular/router'
import { ShoppingCartService } from '../cart.service'
import { Observable } from 'rxjs'
import { ShoppingCart } from '../cart.model'
import { Item } from '../cart-item/cart-item.component'
import { LaunchDialogService } from '@spartacus/storefront'

import moment from 'moment'
import { Actions, ofType } from '@ngrx/effects'
import { filter, take } from 'rxjs/operators'
import { CheckoutService } from '../../checkout/checkout/checkout.service'
import { CartActions } from '@spartacus/cart/base/core'
import {
  ACCESSIBILITY,
  UserRoleService,
} from '../../../../shared/services/user-role.service'
import { SpinnerOverlayService } from '../../../../shared/components/spinner-overlay/spinner-overlay.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'
import {
  Ecommerce,
  EcommerceItem,
  GTMCartType,
  GTMDataLayer,
} from '../../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../../shared/services/gtm.service';
import { QuoteCartFacade } from '../../../cart/mini-cart/store/mini-quote-cart.facade';

@Component({
  standalone: false,
  selector: 'vs-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
})
export class OrderSummaryComponent implements OnInit, OnDestroy {
  @Input()
  cart$: Observable<ShoppingCart>

  // @Input()
  entries: Item[]

  cart: ShoppingCart

  @Input()
  userType = 'current'

  @Output()
  scrollToEntry: EventEmitter<any> = new EventEmitter()

  cartId$: Observable<string> = this.activeCartFacade.getActiveCartId()
  orderType = 'For Resale'
  cartId: string
  completeOrderDialog

  consolidatedShipmentSubscription: any
  isPartialSubscription: any
  coupon = ''
  couponApplied = false
  couponErrorMsg = false
  noValueCouponMsg = false

  isDeliveryErrorSubscription: any
  deliveryErrors: any[] = []
  accessibility = ACCESSIBILITY
  soldToSelected: boolean
  mergeEntries: any[] = []

  constructor(
    protected routingService: RoutingService,
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private activeCartFacade: ActiveCartFacade,
    private multiCartFacade: MultiCartFacade,
    private globalMessageService: GlobalMessageService,
    private launchDialogService: LaunchDialogService,
    private spinnerOverlayService: SpinnerOverlayService,
    private actions$: Actions,
    private cartVoucherFacade: CartVoucherFacade,
    private cdRef: ChangeDetectorRef,
    private checkoutService: CheckoutService,
    private userRoleService: UserRoleService,
    private translate: TranslationService,
    private gtmService: GoogleTagManagerService,
    private quoteCartFacade: QuoteCartFacade
  ) {
    this.cartId$.subscribe(
      (success) => {
        this.cartId = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  ngOnInit(): void {
    this.cart$.subscribe(
      (res) => {
        this.cart = Object.assign({}, res)

        this.entries = this.cart.entries

        if (this.cart.appliedVouchers?.length > 0) {
          this.couponApplied = true
          this.coupon = this.cart.appliedVouchers[0].voucherCode
        } else {
          this.couponApplied = false
          this.coupon = ''
        }
        // this.cdRef.detectChanges();
        this.spinnerOverlayService.hide()
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.shoppingCartService.getSelectedSoldTo.subscribe((value) => {
      this.soldToSelected = value
    })
    this.shoppingCartService.setConsolidatedShipment(
      this.cart.isConsolidatedShipment
    )
    this.consolidatedShipmentSubscription =
      this.shoppingCartService.isConsolidatedShipment$.subscribe(
        (res) => {
          if (this.cart.isConsolidatedShipment != res) {
            this.cart.isConsolidatedShipment = res
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )

    this.shoppingCartService.setShippingType(this.cart.partialShipping)
    this.isPartialSubscription =
      this.shoppingCartService.isShippingTypePartial$.subscribe(
        (res) => {
          if (this.cart.partialShipping != res) {
            this.cart.partialShipping = res
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )

    this.isDeliveryErrorSubscription =
      this.shoppingCartService.deliveryGrpCartEntryError$.subscribe(
        (res) => {
          this.deliveryErrors = res.entryNumbers
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  ngOnDestroy(): void {
    if (this.consolidatedShipmentSubscription) {
      this.consolidatedShipmentSubscription.unsubscribe()
    }
    if (this.isDeliveryErrorSubscription) {
      this.isDeliveryErrorSubscription.unsubscribe()
    }
    if (this.isPartialSubscription) {
      this.isPartialSubscription.unsubscribe()
    }
    this.deliveryErrors = []
  }

  convertToQuoteCart() {
    this.spinnerOverlayService.show()
    const items = this.shoppingCartService.populateQuoteConvertRequest(
      this.cart.entries
    )
    this.shoppingCartService
      .convertToQuoteCart(this.userType, this.cartId, items)
      .subscribe(
        (res) => {
          /* this.spinnerOverlayService.hide();
        this.router.navigate(['/quote/cart']); */
          this.multiCartFacade.loadCart({
            userId: this.userType,
            cartId: this.cartId,
            extraData: {
              active: true,
            },
          });
          
          this.quoteCartFacade.loadCart();

          this.actions$
            .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
            .subscribe(
              (r) => {
                this.spinnerOverlayService.hide()
                this.router.navigate(['/quote/cart'])
              },
              (error) => {
                this.spinnerOverlayService.hide()
                this.globalMessageService.add(
                  error,
                  GlobalMessageType.MSG_TYPE_ERROR,
                  5000
                )
                window.scrollTo(0, 0)
              }
            )
        },
        (err) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            { key: 'savedCart.addToquoteCartFailed' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
          window.scroll(0, 0)
        }
      )
  }

  proceedToCheckout() {
    /**
     * bypass for quote cart type
     */
    if (this?.entries?.length > 150) {
      let removeCount = this?.entries?.length - 150
      /*  let errorMsg;
      errorMsg = `The maximum limit for a shopping cart is 150 entries. The existing shopping cart has ${this?.entries?.length} entries. Please remove the ${removeCount} entries` */
      this.globalMessageService.add(
        {
          key: 'savedCart.maximumLimit',
          params: {
            removeCountJson: removeCount,
            entryLength: this?.entries?.length,
          },
        },
        GlobalMessageType.MSG_TYPE_ERROR,
        5000
      )
      window.scrollTo(0, 0)
      return
    } else {
      this.shoppingCartService.proceedClicked(true)
      if (!this.soldToSelected) {
        return
      } else {
        if (this.cart?.quoteCartType) {
          this.setGTMTagsForCheckoutBegin();
          this.router.navigate(['/cart/checkout'])
          return
        }
        if (this.validateCart() && !this.cart?.quoteCartType) {
          this.getEligibleBuyCartMergeEntries();
        }
      }
    }
  }

  getEligibleBuyCartMergeEntries() {
    this.mergeEntries = [];
    this.spinnerOverlayService.show();
    
    this.shoppingCartService
      .getEligibleMergeEntries(this.cartId)
      .subscribe(
        (res: any) => {
          this.spinnerOverlayService.hide();
          if(res?.entries?.length > 0) {
            this.mergeEntries = res?.entries;
            this.openMergeCartsCheckoutDialog();
          } else{
            this.goToCheckoutPage();
          }
        },
        (err) => {
          this.spinnerOverlayService.hide();
          this.globalMessageService.add(
            err.error.errors[0].message,
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          );
          window.scroll(0, 0);
        }
      )
  }

  mergeEligibleBuyCartEntries() {
    this.spinnerOverlayService.show();
    
    this.shoppingCartService
      .mergeBuyCartEntries(this.cartId, this.mergeEntries)
      .subscribe(
        (res: any) => {
          this.spinnerOverlayService.hide();
          this.multiCartFacade.loadCart({
            userId: this.userType,
            cartId: this.cart.code,
            extraData: {
              active: true,
            },
          });

          this.goToCheckoutPage();
        },
        (err) => {
          this.spinnerOverlayService.hide();
          this.globalMessageService.add(
            err.error.errors[0].message,
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          );
          window.scroll(0, 0);
        }
      )
  }

  openMergeCartsCheckoutDialog() {
    const componentdata = {
      cart: this.cart,
      userType: this.userType,
      cartType: 'BUY_CART'
    }

    const mergeCheckoutCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.MERGE_CHEKOUT_CART_ITEMS,
      undefined,
      undefined,
      componentdata
    )
    if (mergeCheckoutCartDialog) {
      mergeCheckoutCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.MERGE_CHEKOUT_CART_ITEMS
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.reason == 'merge-checkout-cart') {
            this.mergeEligibleBuyCartEntries();
          } else if (value?.reason == 'no-merge-checkout-cart') {
            this.goToCheckoutPage();
          }
        })
    }
  }

  validateCart() {
    this.findCheckAvailability()
      .subscribe(
        (res) => {
          if (res.length > 0) {
            // const checkAvailLineItems = this.getErrorLineItems(res);
            const noStockLineItems = this.getCartErrorLineItemsArr(res)
            // this.globalMessageService.add(
            //   `Please verify the availability of <b>Line #${noStockLineItems
            //     .map((e) => e.join(' and Parts '))
            //     .join(', #')}</b> before proceeding to checkout`,
            //   GlobalMessageType.MSG_TYPE_WARNING,
            //   30000
            // );
            let msg = 'There is an error in line <b>'
            let middleText = ''
            let middleText2 = ''
            let endText =
              '.</b> Please see them highlighted below with and update them as necessary.'
            for (let i = 0; i < Math.min(5, noStockLineItems.length); i++) {
              middleText =
                middleText + '#' + (parseInt(noStockLineItems[i][0]) + 1) + ' '
            }
            if (noStockLineItems?.length > 5) {
              middleText2 = 'and ' + (noStockLineItems?.length - 5) + ' others'
            }
            const finalMsg = msg + middleText + middleText2 + endText

            console.log(finalMsg)
            this.globalMessageService.add(
              finalMsg,
              GlobalMessageType.MSG_TYPE_WARNING,
              30000
            )
            window.scroll(0, 0)
            return false
          } else {
            const noStockItems: any[] = this.findNoStockItems()
            const splitItems: any[] = this.findSplitAvailability()
            const minOrderQuantity: any[] = this.findMinOrderQuantityItems()
            if (noStockItems.length > 0) {
              // const noStockLineItems = this.getErrorLineItems(noStockItems);
              const noStockLineItems =
                this.getCartErrorLineItemsArr(noStockItems)
              // this.globalMessageService.add(
              //   `<b>Line #${noStockLineItems
              //     .map((e) => e.join(' and Parts '))
              //     .join(
              //       ', #'
              //     )}</b> is not available on the date requested. Please either select a different date or request a quote.`,
              //   GlobalMessageType.MSG_TYPE_WARNING,
              //   30000
              // );
              let msg = 'There is an error in line <b>'
              let middleText = ''
              let middleText2 = ''
              let endText =
                '.</b> Please see them highlighted below with and update them as necessary.'
              for (let i = 0; i < Math.min(5, noStockLineItems.length); i++) {
                middleText =
                  middleText +
                  '#' +
                  (parseInt(noStockLineItems[i][0]) + 1) +
                  ' '
              }
              if (noStockLineItems?.length > 5) {
                middleText2 =
                  'and ' + (noStockLineItems?.length - 5) + ' others'
              }
              const finalMsg = msg + middleText + middleText2 + endText
              this.globalMessageService.add(
                finalMsg,
                GlobalMessageType.MSG_TYPE_WARNING,
                30000
              )
              window.scroll(0, 0)
              return false
            } else if (splitItems.length > 0) {
              // const splitStockLineItems = this.getErrorLineItems(splitItems);
              const noStockLineItems =
                this.getCartErrorLineItemsArr(noStockItems)
              // this.globalMessageService.add(
              //   `Please split <b>Line #${noStockLineItems
              //     .map((e) => e.join(' and Parts '))
              //     .join(', #')}</b> before proceeding to checkout`,
              //   GlobalMessageType.MSG_TYPE_WARNING,
              //   30000
              // );
              let msg = 'There is an error in line <b>'
              let middleText = ''
              let middleText2 = ''
              let endText =
                '.</b> Please see them highlighted below with and update them as necessary.'
              for (let i = 0; i < Math.min(5, noStockLineItems.length); i++) {
                middleText =
                  middleText +
                  '#' +
                  (parseInt(noStockLineItems[i][0]) + 1) +
                  ' '
              }
              if (noStockLineItems?.length > 5) {
                middleText2 =
                  'and ' + (noStockLineItems?.length - 5) + ' others'
              }
              const finalMsg = msg + middleText + middleText2 + endText
              this.globalMessageService.add(
                finalMsg,
                GlobalMessageType.MSG_TYPE_WARNING,
                30000
              )
              window.scroll(0, 0)
              return false
            } else if (minOrderQuantity.length > 0) {
              const moqLineItems =
                this.getCartErrorLineItemsArr(minOrderQuantity)

              let msg = 'There is an error in line <b>'
              let middleText = ''
              let middleText2 = ''
              let endText =
                '.</b> Please see them highlighted below with and update them as necessary.'
              for (let i = 0; i < Math.min(5, moqLineItems.length); i++) {
                middleText =
                  middleText + '#' + (parseInt(moqLineItems[i][0]) + 1) + ' '
              }
              if (moqLineItems?.length > 5) {
                middleText2 = 'and ' + (moqLineItems?.length - 5) + ' others'
              }
              const finalMsg = msg + middleText + middleText2 + endText
              this.globalMessageService.add(
                finalMsg,
                GlobalMessageType.MSG_TYPE_WARNING,
                30000
              )
              window.scroll(0, 0)
              return false
            } else if (
              this.cart.partialShipping &&
              !this.validateDeliveryGroups()
            ) {
              return false
            } else if (this.deliveryErrors?.length > 0) {
              this.scrollToEntry.emit(this.deliveryErrors[0])
              return false
            } else {
              this.shoppingCartService.isShippingTypePartial$
                .subscribe((sucess) => {
                  if (!sucess) {
                    // this.cart.partialShipping = false;
                    // this.shoppingCartService.setShippingType(sucess);

                    this.spinnerOverlayService.show()

                    this.shoppingCartService
                      .changeShippingType(
                        this.userType,
                        this.cartId,
                        'complete',
                        true
                      )
                      .subscribe(
                        (success: any) => {
                          this.spinnerOverlayService.hide()
                          if (success?.differentAvailabilityCode == 1001) {
                            this.globalMessageService.add(
                              { key: 'savedCart.shipmentTypeChangedToPartial' },
                              GlobalMessageType.MSG_TYPE_ERROR,
                              10000
                            )
                            window.scroll(0, 0)
                            this.cart.partialShipping = true
                            this.shoppingCartService.setShippingType(true)
                          } else if (
                            success?.differentAvailabilityCode == 1002
                          ) {
                            this.openEarliestShipDateDialog()
                          } else {
                            let consShipEntryErrors = []
                            if (
                              this.cart.consolidatedDay &&
                              this.cart.isConsolidatedShipment
                            ) {
                              for (const entry of this.entries) {
                                const weekDayName = moment(
                                  entry.assignedShipDate
                                ).format('dddd')
                                let selectedDay = this.cart.consolidatedDay
                                  ?.toLocaleLowerCase()
                                  .split(',')
                                let weekDay = weekDayName.toLocaleLowerCase()
                                if (!selectedDay.includes(weekDay)) {
                                  consShipEntryErrors.push(entry.entryNumber)
                                }
                              }
                              if (consShipEntryErrors.length > 0) {
                                this.shoppingCartService.setConsErrors(
                                  consShipEntryErrors
                                )
                                this.scrollToEntry.emit(consShipEntryErrors[0])
                                return
                              } else {
                                //this.goToCheckoutPage()
                                this.getEligibleBuyCartMergeEntries();
                              }
                            } else {
                              consShipEntryErrors = []
                              //this.goToCheckoutPage()
                              this.getEligibleBuyCartMergeEntries();
                            }
                          }
                        },
                        (error) => {
                          this.spinnerOverlayService.hide()
                        }
                      )
                  } else {
                    let consShipEntryErrors = []
                    if (this.cart.isConsolidatedShipment) {
                      for (const entry of this.entries) {
                        const weekDayName = moment(
                          entry.assignedShipDate
                        ).format('dddd')
                        let selectedDay = this.cart.consolidatedDay
                          ?.toLocaleLowerCase()
                          .split(',')
                        let weekDay = weekDayName.toLocaleLowerCase()
                        if (!selectedDay.includes(weekDay)) {
                          consShipEntryErrors.push(entry.entryNumber)
                        }
                      }
                      if (consShipEntryErrors.length > 0) {
                        this.shoppingCartService.setConsErrors(
                          consShipEntryErrors
                        )
                        this.scrollToEntry.emit(consShipEntryErrors[0])
                        return
                      } else {
                        //this.goToCheckoutPage()
                        this.getEligibleBuyCartMergeEntries();
                      }
                    } else {
                      consShipEntryErrors = []
                      //this.goToCheckoutPage()
                      this.getEligibleBuyCartMergeEntries();
                    }
                  }
                })
                .unsubscribe()
            }
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
      .unsubscribe()

    return false
  }

  goToCheckoutPage() {
    this.clearValues()
    if (this.cart.surCharge?.value > 0) {
      this.openMinOrderConfirmationDialog()
    } else {
      this.redirectToCheckoutPage()
    }
  }

  clearValues() {
    this.checkoutService.orderpreferences.next({})
    this.checkoutService.shippinginstructions.next({})
    let obj = { code: '', name: '', selected: 'false' }
    this.checkoutService.specialdocSIData.next(obj)
    this.checkoutService.finaltestSIData.next(obj)
    this.checkoutService.valvesdimenSIData.next(obj)
    this.checkoutService.othersSIData.next(obj)
    this.checkoutService.inspectionTestSIData.next(obj)
    this.checkoutService.cMTRSSIData.next(obj)
    this.checkoutService.iNstructionSIData.next(obj)
    // this.checkoutService.bankGuaranteeData.next(obj);
    this.checkoutService.witnessInspctnData.next(obj)
    this.checkoutService.sendShipDetails('')
    this.checkoutService.getSepcsialInst.next({})
  }

  redirectToCheckoutPage() {
    this.setGTMTagsForCheckoutBegin();
    this.router.navigate(['/cart/checkout'])
  }

  openMinOrderConfirmationDialog() {
    const componentdata = {
      cart: this.cart,
      userType: this.userType,
    }

    const minOrderDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.MIN_ORDER_CONFIRMATION,
      undefined,
      undefined,
      componentdata
    )
    if (minOrderDialog) {
      minOrderDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.MIN_ORDER_CONFIRMATION
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.reason == 'save-min-order') {
            this.redirectToCheckoutPage()
          }
        })
    }
  }

  findNoStockItems() {
    const noStockItems: any[] = []
    for (const entry of this.entries) {
      if (!entry.stockAvailability) {
        noStockItems.push(entry)
      }
    }
    return noStockItems
  }

  findSplitAvailability() {
    const splitItems: any[] = []
    for (const entry of this.entries) {
      if (entry.splitByAvailability) {
        splitItems.push(entry)
      }
    }
    return splitItems
  }

  findMinOrderQuantityItems() {
    const minOrderQuantity: any[] = []
    for (const entry of this.entries) {
      if (entry.minOrderQuantity > entry.quantity) {
        minOrderQuantity.push(entry)
      }
    }
    return minOrderQuantity
  }

  findCheckAvailability(): Observable<any> {
    return this.shoppingCartService.isCheckAvailability$
  }

  getErrorLineItems(stockItems) {
    const entryNums = []
    const entryProductCodes = []
    stockItems.forEach((element: any) => {
      let entryNum = Number(element.entryNumber)
      entryNums.push(++entryNum)
      entryProductCodes.push(element.product?.code)
    })
    return {
      entryNums: entryNums,
      entryProductCodes: entryProductCodes,
    }
  }

  /* 
    Inputs cart items array
    Returns array of arrays with each nested array containing line # and part number
    eg.: [[1, '1234'], [2, '5678']]
  */
  getCartErrorLineItemsArr(stockItems) {
    const errorDetailArr = []
    stockItems.forEach((element: any) => {
      let entryNum = Number(element.entryNumber)
      const entryDetail = []
      entryDetail.push(entryNum, element.product?.code)
      errorDetailArr.push(entryDetail)
    })
    return errorDetailArr
  }

  validateDeliveryGroups() {
    if (!this.cart?.entries[0]?.deliveryGroupNumber) {
      return true
    }
    let errors: any = {}
    errors = this.shoppingCartService.validateDeliveryGroups(this.cart.entries)
    if (errors?.type == '101') {
      return true
    }
    if (errors?.entryNumbers.length > 0) {
      this.shoppingCartService.setDeliveryGroupErrors(errors)
      this.scrollToEntry.emit(errors.entryNumbers[0])
      return false
    }
    return true
  }

  openEarliestShipDateDialog() {
    const componentdata = {
      earliestShipDate: this.getEarliestShipDate(this.cart),
    }

    const completeOrderDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.COMPLETE_ORDER,
      undefined,
      undefined,
      componentdata
    )
    if (completeOrderDialog) {
      completeOrderDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.COMPLETE_ORDER
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.reason == 'success-order') {
            const shipdate = value?.data
            this.applyReqShipDate(shipdate)
          } else {
            this.cart.partialShipping = true
            this.shoppingCartService.setShippingType(true)
            this.globalMessageService.add(
              { key: 'savedCart.shipmentTypeChangedToPartial2' },
              GlobalMessageType.MSG_TYPE_WARNING,
              10000
            )
            window.scroll(0, 0)
          }
        })
    }
  }

  applyReqShipDate(shipDateParam?) {
    const reqShipDate = shipDateParam
    if (this.cart.isConsolidatedShipment) {
      const weekDayName = moment(reqShipDate).format('dddd')
      let selectedDay = this.cart.consolidatedDay
        ?.toLocaleLowerCase()
        .split(',')
      let weekDay = weekDayName.toLocaleLowerCase()
      if (!selectedDay.includes(weekDay)) {
        this.globalMessageService.add(
          { key: 'savedCart.selectRequestedShip' },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scroll(0, 0)
        return
      }
    }

    // this.showShipDateLoader = true;
    this.spinnerOverlayService.show()
    this.shoppingCartService
      .changeRequestShipDate(reqShipDate, this.userType, this.cart.code)
      .subscribe(
        (res) => {
          this.spinnerOverlayService.hide()
          this.goToCheckoutPage()
          /* this.multiCartService.loadCart({
          userId: this.userType,
          cartId: this.cart.code,
          extraData: {
            active: true,
          },
        }); */
          // this.showShipDateLoader = false;
        },
        (error: any) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            { key: 'savedCart.errorWhileApplyingShipDate' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
          // this.showShipDateLoader = false;
        }
      )
  }

  getEarliestShipDate(cartData) {
    const dates = []
    for (const entry of cartData.entries) {
      dates.push(entry.assignedShipDate)
    }
    const moments = dates.map((d) => moment(d))
    return moment(moment.max(moments)).format('YYYY/MM/DD')
  }

  getCouponDiscout() {
    if (this.cart.productCouponDiscount?.value > 0) {
      return this.cart.productCouponDiscount?.formattedValue
    }
    return this.cart.orderDiscounts?.formattedValue
  }

  applyCoupon() {
    this.spinnerOverlayService.show()
    this.cartVoucherFacade.addVoucher(this.coupon, this.cartId)
    this.actions$.pipe(ofType(CartActions.CART_ADD_VOUCHER_SUCCESS)).subscribe(
      (success: any) => {
        this.couponApplied = true
        this.coupon = success.payload?.voucherId
        // this.spinnerOverlayService.hide();
        this.cdRef.detectChanges()
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.actions$.pipe(ofType(CartActions.CART_ADD_VOUCHER_FAIL)).subscribe(
      (err: any) => {
        this.couponErrorMsg = false
        this.noValueCouponMsg = false
        const couponErr = JSON.parse(err.payload.error.error)
        if (
          couponErr?.errors[0]?.message ==
          'coupon.code.expectationNotMet.provided'
        ) {
          this.noValueCouponMsg = true
        } else {
          this.couponErrorMsg = true
        }
        this.couponApplied = false
        this.coupon = ''
        this.spinnerOverlayService.hide()
        this.cdRef.detectChanges()
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    /* this.actions$.pipe(ofType(CartActions.LOAD_CART_SUCCESS)).subscribe((success: any) => {
      this.couponApplied = true;
      this.coupon = success.payload?.cart?.appliedVouchers[0]?.code;
      this.spinnerOverlayService.hide();
    }); */
  }

  removeCoupon() {
    this.spinnerOverlayService.show()
    this.cartVoucherFacade.removeVoucher(this.coupon, this.cartId)

    /* this.actions$.pipe(ofType(CartActions.LOAD_CART_SUCCESS)).subscribe((success) => {
      this.couponApplied = false;
      this.coupon = '';
      this.spinnerOverlayService.hide();
    }); */
  }

  applyCoupon_old() {
    this.spinnerOverlayService.show()
    this.shoppingCartService
      .applyCoupons(this.userType, this.cartId, this.coupon)
      .subscribe(
        (res) => {
          this.multiCartFacade.loadCart({
            userId: this.userType,
            cartId: this.cartId,
            extraData: {
              active: true,
            },
          })
          this.actions$
            .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
            .subscribe(
              (success) => {
                this.couponApplied = true
                this.spinnerOverlayService.hide()
              },
              (error) => {
                this.spinnerOverlayService.hide()
                this.globalMessageService.add(
                  error,
                  GlobalMessageType.MSG_TYPE_ERROR,
                  5000
                )
                window.scrollTo(0, 0)
              }
            )
        },
        (error) => {
          this.spinnerOverlayService.hide()
          if (error.error.errors[0].message == 'coupon.invalid.code.provided') {
            this.globalMessageService.add(
              { key: 'savedCart.invalidCoupon' },
              GlobalMessageType.MSG_TYPE_ERROR,
              20000
            )
          } else {
            this.globalMessageService.add(
              { key: 'savedCart.errorwhileApplyingCoupon' },
              GlobalMessageType.MSG_TYPE_ERROR,
              20000
            )
          }
        }
      )
  }

  removeCoupon_old() {
    this.spinnerOverlayService.show()
    this.shoppingCartService
      .removeCoupon(this.userType, this.cartId, this.coupon)
      .subscribe(
        (suc) => {
          this.multiCartFacade.loadCart({
            userId: this.userType,
            cartId: this.cartId,
            extraData: {
              active: true,
            },
          })
          /* this.actions$.pipe(ofType(CartActions.LOAD_CART_SUCCESS)).subscribe((res) => {
        this.couponApplied = false;
        this.coupon = '';
        this.spinnerOverlayService.hide();
      }) */
          this.couponApplied = false
          this.coupon = ''
          this.spinnerOverlayService.hide()
        },
        (error) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            { key: 'savedCart.errorWhileRemovingCoupon' },
            GlobalMessageType.MSG_TYPE_ERROR,
            20000
          )
        }
      )
  }

  checkUserEnabled(flagName) {
    return this.userRoleService.checkUserRoleEnabled(flagName)
  }

  setGTMTagsForCheckoutBegin() {
    let items: EcommerceItem[] = [];
    if (this?.entries.length > 0) {
      this?.entries.forEach((item, i) => {
        let eachitem: EcommerceItem = {
          item_id: item?.product?.code,
          item_name: item?.product?.name,
          index: i,
          item_list_id: ItemListTypeEnum.Cart,
          item_list_name: ItemListTypeEnum.Cart,
          price: item?.netPrice?.value,
          quantity: item?.quantity,
        };
        items.push(eachitem);
      });
    }

    let checkoutBeginEcommerce: Ecommerce = {
      currency: this.cart?.totalPrice?.currencyIso,
      value: this.cart?.totalPrice?.value ?? 0,
      items: items,
    };

    let checkoutBeginDataLayer: GTMDataLayer = {
      event: GtmEvents.BeginCheckout,
      ecommerce: checkoutBeginEcommerce,
      commerceType: GTMCartType.BUY_CART,
      cart_id: this.cartId
    };
    this.gtmService.sendEvent(checkoutBeginDataLayer);
  }
}
